<template>
  <div>
    <div class="crumbs"><a href="/download_app">美菜商城</a> > 售后准则</div>

    <div class="member">
      <div class="rule">
        <h2><span class="bule"></span>退换货业务受理范围</h2>
        <div class="rule-info">
          1 .
          生鲜类（蔬菜水果、鲜肉禽蛋、海鲜水产、冷藏或冻货、面点等）商品自客户签收订单18小时内，如是美菜网原因或商品质量问题，我们将及时为您进行退货；
          <br />2 .
          非生鲜类（米面粮油，调料干货，厨房用品等）自客户签收订单七天内，可享受“无理由退货”政策。
        </div>
      </div>
      <div class="rule">
        <h2><span class="yellow"></span>退货必备条件</h2>
        <div class="rule-info">
          1 .
          问题货品，请确保商品包装无破损；商品、赠品（如购买时有赠品）、说明书、发票、均齐全；
          <br />2 .
          如申请退货的商品为成套商品中的一个商品如礼盒、礼包，则需退此整套商品。
        </div>
      </div>
      <div class="rule">
        <h2><span class="red"></span>注意事项</h2>
        <div class="rule-info">
          1 .
          为保障客户权益，请客户签收前与配送人员当面核对货品（含赠品）是否与订单一致，确认无误后再签收；
          <br />2 .
          如申请退货的商品为成套商品中的一个商品如礼盒、礼包，则需退此整套商品；
          <br />3 .
          生鲜类及非生鲜类货品均在规定时间内受理退换货要求，若超过相关时限，我们将不再受理；
          <br />4 .
          图片及信息仅供参照，商品将以实物为准。因拍摄灯光及不同显示器色差等问题可能造成商品图片与实物有一定色差，不属质量问题；
          <br />5 .
          代金券不可折现，不找零，若您在使用后发生整体退货，所使用代金券不予退还，只退还实际支付金额；
          <br />6 .
          通常一张订单只能进行一次退换货操作，为了确保您的权益，请全部检验完毕后与我们联系。
        </div>
      </div>
      <div class="rule">
        <h2>
          <span class="green"></span>若属于下列情形，本公司不承担退换货责任
        </h2>
        <div class="rule-info">
          1 . 如因客户个人原因或保管不当造成质量问题的商品，不予退换；
          <br />2 .
          误用或不正确的储存、烹饪、使用等方法所造成的质量问题，或撕毁、涂改标贴、防伪标记的商品，不予退换货；
          <br />3 . 所有赠品不予退换； <br />4 .
          对于货品数量不足、错货或无货的情况，司机可受理当场提出的退换货要求，即货物送达后，收货人员当场清点货品数量，如有疑义，当场即时提出，一旦签收，我们将不再受理此类退换货。
        </div>
      </div>
    </div>
    <div class="hot-tel">
      美菜客服热线：{{ $concatPhone || "4006-135-135" }}
    </div>
    <HomeFooter />
  </div>
</template>

<script>
import HomeFooter from "../home/components/footer";
export default {
  name: "partner",
  components: {
    HomeFooter,
  },
  data() {
    return {
      dialogVisbility: false,
    };
  },
  methods: {
    showForm() {
      this.dialogVisbility = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.crumbs {
  width: 1000px;
  margin: 0 auto;
  padding: 20px 0;
  color: #757575;
  font-size: 14px;
}
.crumbs a {
  color: #757575;
}
.crumbs a:hover {
  color: #63ac48;
}
.member {
  width: 998px;
  margin: 0 auto 50px;
  border: 1px solid #d8d8d8;
}
.rights h2,
.rule h2 {
  font-size: 18px;
  background: #f2f2f2;
  height: 40px;
  padding-left: 20px;
  line-height: 40px;
}

.rule span {
  width: 2px;
  height: 16px;
  background: #3593f7;
  float: left;
  margin: 12px 8px 0 -10px;
}
.rule span.blue {
  background: #3593f7;
}
.rule span.yellow {
  background: #f8c309;
}
.rule span.red {
  background: #f76064;
}
.rule span.green {
  background: #00a615;
}
.hot-tel {
  background: url(https://img-oss.yunshanmeicai.com/cfile/1e5663811a07329322bad2f37bb88fb1.png)
    no-repeat left 0;
  font-size: 18px;
  background-size: 25px;
  padding: 2px 0 55px 32px;
  margin: 0 auto;
  width: 284px;
}

.rights-list {
  padding: 40px 0;
  font-size: 0;
}
.rights-list dl {
  width: 250px;
  display: inline-block;
  margin: 0 40px;
  font-size: 14px;
}
.rights-list dl dt {
  float: left;
}
.rights-list dl dd {
  float: left;
  font-size: 16px;
  padding: 20px 0 0 20px;
}
.rights-list dl div {
  clear: both;
  padding-top: 20px;
  line-height: 1.8;
}
.rights-list dl.yellow-m dd {
  color: #f5a623;
}
.rights-list dl.bule-m dd {
  color: #0496fe;
}
.rights-list dl.red-m dd {
  color: #f76064;
}
.rule-info {
  padding: 25px 20px;
  color: #565656;
  line-height: 2.3;
}
.rule-info b {
  color: #383838;
}

.rule-info table {
  width: 850px;
  margin: 20px auto 0;
}
.rule-info table tr td {
  border: 1px solid #7ed321;
  padding: 5px 0 5px 30px;
}
.rule-info table tr td em {
  font-size: 12px;
  color: #757575;
}

.rule-info div {
  line-height: 20px;
  margin-top: 1px;
  padding-left: 23px;
  font-size: 12px;
  height: 20px;
  color: #fff;
}
.rule-info .grade-a div {
  background: url(https://img-oss.yunshanmeicai.com/cfile/1f5e1b0de326eed63b06dc5f909b86fb.png)
    no-repeat;
  background-size: 76px;
}
.rule-info .grade-b div {
  background: url(https://img-oss.yunshanmeicai.com/cfile/c8bde788fa5a73c92bc6ff34d5688033.png)
    no-repeat;
  background-size: 76px;
}
.rule-info .grade-c div {
  background: url(https://img-oss.yunshanmeicai.com/cfile/302c91a529fd3adff90c66437b129941.png)
    no-repeat;
  background-size: 76px;
}
</style>
